import { FC } from 'react';
import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { pxToRem } from 'utils/convert';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const SkeletonComponentsContainer = styled(FlexSpacer)`
  padding: ${pxToRem(40)} 0 0 0 !important;
  margin-bottom: ${spacing.x7};
  gap: ${spacing.doubleQuarter} !important;
`;

export const UpsertSkeletonId = 'skeleton-loader';

export interface UpsertPageSkeletonProps {
  testId: string;
}
export const UpsertPageSkeleton: FC<UpsertPageSkeletonProps> = ({ testId }) => {
  return (
    <SkeletonComponentsContainer flexDirection="column" data-test={`${testId}-${UpsertSkeletonId}`}>
      <Skeleton height={400} />
      <Skeleton height={240} />
    </SkeletonComponentsContainer>
  );
};
